export const MATERIALS_ORDER_TOPIC = 'materials_order';
export const QUANTITY_UNIT = 'und';

export const MATERIALS_ORDER_NOTE_FIELD = {
  label: 'Nota (opcional)',
  maxLength: 1000,
  placeholder: 'Algo que debamos saber del pedido, por ejemplo para cuándo lo necesitas.',
};

const MATERIALS_ORDER_SUBJECT = 'Pedido de materiales';

const PREFERRED_GROUP_BY_LINE = {
  'Menu Diario': 'daily',
  'On Demand': 'food',
  Franchises: 'food',
};

const GROUP_LABELS = {
  daily: 'Menú Diario',
  food: 'Food',
  general: 'General',
};

const NON_DIGITS = /\D/g;
const MIN_QUANTITY = 1;
const SUMMARY_LOCALE = 'es-PE';
const SINGLE_PRODUCT = 1;

export function groupCatalogItems(items, businessLine) {
  const groups = items.reduce((grouped, item) => {
    const existing = grouped.find((group) => group.key === item.group);
    if (!existing) return [...grouped, { key: item.group, items: [item] }];
    return grouped.map((group) => (group === existing ? { ...group, items: [...group.items, item] } : group));
  }, []);
  const preferredGroup = preferredGroupKey(businessLine);

  return [
    ...groups.filter((group) => group.key === preferredGroup),
    ...groups.filter((group) => group.key !== preferredGroup),
  ];
}

export function preferredGroupKey(businessLine) {
  return PREFERRED_GROUP_BY_LINE[businessLine] || null;
}

export function presetsForItem(item, catalogPresets) {
  if (Array.isArray(item.presets) && item.presets.length) return item.presets;
  return Array.isArray(catalogPresets) ? catalogPresets : [];
}

export function groupLabel(groupKey) {
  return GROUP_LABELS[groupKey] || groupKey;
}

export function withQuantity(selection, materialId, quantity) {
  const remaining = Object.keys(selection)
    .filter((key) => key !== String(materialId))
    .reduce((kept, key) => ({ ...kept, [key]: selection[key] }), {});

  return quantity ? { ...remaining, [materialId]: quantity } : remaining;
}

export function togglePreset(selection, materialId, preset) {
  return withQuantity(selection, materialId, selection[materialId] === preset ? null : preset);
}

export function onlyDigits(rawValue) {
  return String(rawValue || '').replace(NON_DIGITS, '');
}

export function parseCustomQuantity(rawValue, maxQuantity) {
  const digits = onlyDigits(rawValue);
  if (!digits) return null;

  const quantity = Number(digits);
  return quantity >= MIN_QUANTITY && quantity <= maxQuantity ? quantity : null;
}

export function hasSelectedItems(selection) {
  return Object.keys(selection || {}).length > 0;
}

export function formatQuantity(quantity) {
  return quantity.toLocaleString(SUMMARY_LOCALE);
}

export function selectionSummaryLabel(selection) {
  const quantities = Object.values(selection);
  const totalUnits = quantities.reduce((total, quantity) => total + quantity, 0);
  const products = quantities.length === SINGLE_PRODUCT ? 'producto' : 'productos';

  return `${quantities.length} ${products} · ${formatQuantity(totalUnits)} ${QUANTITY_UNIT}`;
}

export function toItemFields(selection) {
  return Object.keys(selection).flatMap((materialId, index) => [
    [`items[${index}][material_id]`, materialId],
    [`items[${index}][quantity]`, String(selection[materialId])],
  ]);
}

export function subjectForTopic(topic, subject) {
  return topic === MATERIALS_ORDER_TOPIC ? MATERIALS_ORDER_SUBJECT : subject;
}

export function isBusinessLineRequired(topic) {
  return topic !== MATERIALS_ORDER_TOPIC;
}
